module.exports = __webpack_public_path__ + "img/email.19616aca.svg";